module.exports = __webpack_public_path__ + "images/ExternalPromo/weebly-378914-728_90.gif?9e1a5";